// eslint-disable
import axios from 'axios'

export const BASE_URL = window.apiPath ? window.apiPath : process.env.API_PATH

export const IMAGES_URL = BASE_URL + 'documentos/get'

export const DOCUMENTOS_CABECERA_URL = BASE_URL + 'documentos/get_documento_cabecera'

export const DOCUMENTOS_PLANTILLA_URL = BASE_URL + 'documentos/get_documento_plantilla'

export const DOCUMENTOS_CONTRATO_URL = BASE_URL + 'documentos/get_contrato'

export const DOCUMENTOS_SCORING_URL = BASE_URL + 'documentos/get_documento_scoring'

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true
})

export default api



// WEBPACK FOOTER //
// ./src/api/api.js